import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { LabelList } from "recharts";

import {
  FaLeaf,
  FaMoneyBillWave,
  FaBalanceScale,
  FaHome,
  FaWater,
} from "react-icons/fa";
import "./WaterReport2.css";

const savingsData = [
  { type: "Traditional Lawn", value: 30 },
  { type: "Hybrid Turf", value: 20 },
  { type: "Water-wise", value: 10 },
];

const WaterReport2 = () => {
  return (
    <div className="report-wrapper">
      {/* HEADER */}
      <div className="report-header">
        <h1>
          <FaLeaf /> Lawn → Water-Wise Transition
        </h1>
        <p>
          This report explains when people switch from traditional lawns to
          water-wise landscaping and how much water is saved because of it.
        </p>
      </div>

      {/* WHY SWITCH */}
      <div className="section-card">
        <h3>Why People Switch</h3>

        <div className="factor-grid">
          <div className="factor-card">
            <FaMoneyBillWave />
            <h4>Financial Incentives</h4>
            <p>$1–$3 per sq.ft rebates reduce cost</p>
          </div>

          <div className="factor-card">
            <FaBalanceScale />
            <h4>Regulations</h4>
            <p>Tiered pricing & irrigation limits</p>
          </div>

          <div className="factor-card">
            <FaHome />
            <h4>Neighborhood Effect</h4>
            <p>Visible adoption increases trust</p>
          </div>
        </div>
      </div>

      {/* CHART */}
      <div className="section-card">
        <h3>
          <FaWater /> Water Usage Comparison (2024)
        </h3>

        <ResponsiveContainer width="100%" height={360}>
          <BarChart
            data={savingsData}
            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" opacity={0.1} />

            <XAxis
              dataKey="type"
              label={{
                value: "Landscape Type",
                position: "insideBottom",
                offset: -10,
                style: { fill: "#555" },
              }}
            />

            <YAxis
              label={{
                value: "Gallons per sq.ft.",
                angle: -90,
                position: "insideLeft",
                dx: 0,
                dy: 20,
                style: { fill: "#555", textAnchor: "middle" },
              }}
            />

            <Tooltip formatter={(value) => `${value} Gallons per sq. ft.`} />

            <Bar dataKey="value" fill="#60a5fa" radius={[10, 10, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* METRICS */}
      <div className="kpi-row">
        <div className="kpi blue">
          <p></p>
          <h2>3M sq. ft.</h2>
          <p>Lawn replaced (2024)</p>
        </div>

        <div className="kpi green">
          <p></p>
          <h2>100M+</h2>
          <p>Gallons saved (2024)</p>
        </div>

        <div className="kpi purple">
          <h2>33</h2>
          <p>Gallons sq. ft./year (Lawn Removed)</p>
        </div>

        <div className="kpi orange">
          <h2>30K-90K</h2>
          <p>Gallons per year (savings)</p>
        </div>
      </div>

      {/* TABLE */}
      <div className="section-card">
        <h3>Water Savings Breakdown</h3>

        <table className="clean-table">
          <thead>
            <tr>
              <th>Landscape Type</th>
              <th>Water Usage</th>
              <th>Savings</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Traditional Lawn</td>
              <td>25-35 gallons per sq.ft.</td>
              <td>0%</td>
            </tr>
            <tr>
              <td>Hybrid Turf</td>
              <td>15-20 gallons per sq.ft.</td>
              <td>30%</td>
            </tr>
            <tr>
              <td>Water-wise</td>
              <td>5-10 gallons per sq.ft.</td>
              <td>50-70%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WaterReport2;
